module.exports = __webpack_public_path__ + "img/margot-vignette.7952633e.jpg";